export const loginSignupTemplate = ({ currentUrl }) => `
<div class="login-signup-reset">
  <div class="comment--login">
    <svg class="comment--login--close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/>
    </svg>
    <div class="comment--login-headline">Login</div>
    <form class="comment--login-form" action="/core/users/email_login/?next_url=${currentUrl}" method="POST">
        <input id="id_email" required class="comment--login-field" maxlength="100" name="email" placeholder="Enter your email" type="text"/>
        <input id="id_password" required class="comment--login-field" maxlength="100" name="password" placeholder="Enter your password" type="password"/>
        <button type="submit" class="comment--login-button" value="Login">Log In</button>
        <div class="comment--login--message"><a href="javascript:void(0)" class="comment--show_reset_password topbar-login-form__reset-pwd">Forgot your password?</a></div>
        <div class="comment--login--message">if you don't have an account <a href="javascript:void(0)" class="comment--show_signup">sign up here</a></div>
        <div class="comment--login--message requirements hidden">* These fields are required.</div>
        <div class="comment--login--message error hidden"></div>
    </form>
  </div>
  <div class="comment--otp hidden">
    <svg class="comment--login--close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/>
    </svg>
    <div class="comment--login-headline">OTP</div>
    <form class="comment--otp-form" action="/core/v1/users/me/auth/otps/verify?next_url=${currentUrl}" method="POST">
        <input id="id_otp" required class="comment--login-field" maxlength="100" name="otp" placeholder="* Enter your OTP" type="text"/>
        <button type="submit" class="comment--login-button" value="Login">Verify</button>
        <div class="comment--login--message requirements">* These fields are required.</div>
        <div class="comment--login--message error hidden">Invalid Code</div>
    </form>
  </div>
  <div class="comment--signup comment--signup-step1 hidden">
     <svg class="comment--login--close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/>
     </svg>
    <div class="comment--login-headline">Sign Up</div>
        <div class="comment--login--feedback comment--login--errors hidden"></div>
        <input id="next_url" name="next_url" type="hidden" value="${currentUrl}"/>
        <input class="comment--login-field comment--signup-name" maxlength="100" name="name" placeholder="* Enter your name" type="text"/>
        <input class="comment--login-field comment--signup-email" maxlength="100" name="email" placeholder="* Enter your email" type="text"/>
        <input class="comment--login-field  comment--signup-password" maxlength="100" name="password" placeholder="* Enter your password" type="password"/>
        <button type="submit" class="comment--signup-button" value="Login">Sign Up</button>
    <div class="comment--login--message">If you already have an account, <a href="javascript:void(0)" class="comment--show_login">log in here</a></div>
    <div class="comment--login--message requirements">* These fields are required.</div>
    </div>
<div class="comment--signup comment--signup-step2 hidden">
  <div class="comment--login-headline">Add your personal info</div>
      <div class="comment--login--feedback comment--login--errors hidden"></div>
     <div class="site-avatar-edit">
        <div class="community-site-logo" style="background-image: url('https://assets.rbl.ms/18272901/2000x.png');">
         <a href="javascript: void(0)" class="hover-menu edit start-edit" title="Edit" style="display: none;">Edit</a>
         <div class="edit-mode" style="">
             <div class="edit-mode-inner">
                 <div class="community-site-logo logo-preview" style="background-image: url('https://assets.rbl.ms/18272901/2000x.png');">
                 <span class="circle-loader hidden"></span>
                 </div>
                 <div class="site-avatar">
                     <form class="avatar-form" enctype="multipart/form-data" encoding="multipart/form-data" method="GET">
                        <div class="comment--login-headline-subheadline">
                             <label class="fake-input"><input id="fileInput" class="input-file" type="file" name="logo"></label>
                             <a class="ch-cover-upload btn" href="javascript: void(0)"><span><i class="icons-roar upload-from-pc"></i> Upload</span></a>
                        </div>
                        <div style="display: none;" class="progress progress-striped active">
                             <div style="width: 0%;" class="bar"></div>
                            <span class="status-text"></span>
                         </div>
                     </form>
                 </div>
             </div>
         </div>
        </div>
     </div>
      <button type="submit" class="comment--done-button" value="Login">Done</button>
</div>
<div class="comment--reset hidden">
  <svg class="comment--login--close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/>
  </svg>
  <div class="comment--login-headline">Reset Password</div>
  <div class="comment--login--feedback comment--login--errors hidden"></div>
  <div class="comment--login--feedback comment--login--success hidden">We've emailed you instructions for setting your password. You should be receiving them shortly.</div>
  <input class="comment--login-field comment--reset-email" maxlength="100" name="email" placeholder="* Enter your email" type="text"/>
  <button type="submit" class="comment--reset-button" value="Reset">Reset Password</button>
  <div class="comment--login--message">if you don't have an account <a href="javascript:void(0)" class="comment--show_signup">sign up here</a></div>
  <div class="comment--login--message requirements hidden">* These fields are required.</div>
</div>
</div>`;
